import type { SliderMeta } from "../meta";

interface Props {
  metas: SliderMeta[];
  values: Record<string, number>;
  onChange: (key: string, value: number) => void;
  title: string;
  subtitle?: string;
}

export function SliderEditor({ metas, values, onChange, title, subtitle }: Props) {
  return (
    <div>
      <h4 className="text-2xs uppercase tracking-wider text-fg-subtle font-semibold mb-2">
        {title}{" "}
        {subtitle && (
          <span className="normal-case tracking-normal text-fg-muted opacity-70 font-normal text-[10px]">
            {subtitle}
          </span>
        )}
      </h4>
      <div className="flex flex-col gap-3">
        {metas.map((meta) => {
          const value = typeof values[meta.key] === "number" ? values[meta.key] : meta.default;
          return (
            <div
              key={meta.key}
              className="grid items-center gap-3"
              style={{ gridTemplateColumns: "1fr 60px" }}
            >
              <div>
                <div className="text-xs font-medium text-fg">{meta.label}</div>
                <div className="text-2xs text-fg-subtle font-mono mb-1.5">{meta.hint}</div>
                <input
                  type="range"
                  min={meta.min}
                  max={meta.max}
                  step={1}
                  value={value}
                  onChange={(e) => onChange(meta.key, parseInt(e.target.value, 10))}
                  className="w-full"
                  style={{ accentColor: "var(--nx-accent)" }}
                />
              </div>
              <input
                type="number"
                min={meta.min}
                max={meta.max}
                step={1}
                value={value}
                onChange={(e) => {
                  const v = parseInt(e.target.value, 10);
                  if (isNaN(v)) return;
                  onChange(meta.key, Math.max(meta.min, Math.min(meta.max, v)));
                }}
                className="nx-input text-2xs font-mono text-right"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
